module.exports = __webpack_public_path__ + "img/MikotoStory_bk.675f2b45.png";